import { FluxErrorCode } from '@flux/errors';
import { FLUX_ERROR_MESSAGES, type FluxErrorCodeMessage } from '@flux/errors';

export const ERROR_MESSAGES = {
  DEFAULTS: {
    DEFAULT:
      'Ocorreu um erro inesperado. Tente novamente mais tarde ou entre em contato com o suporte se o problema persistir.',
    NETWORK:
      'Não foi possível estabelecer uma conexão com a internet. Verifique sua conexão e tente novamente.',
  },
  USER_DEFINED: FLUX_ERROR_MESSAGES,
  EXTENDED: {
    FORBIDDEN_WITH_PERMISSIONS: (...permissions: string[]) =>
      `Você não tem permissão para interagir com esse recurso. Necessário: ${permissions.map((val) => `"${val}"`).join(', ')}.`,
  },
} satisfies {
  DEFAULTS: Record<string, string>;
  EXTENDED: Record<string, (...args: string[]) => string>;
  USER_DEFINED: Record<FluxErrorCode, FluxErrorCodeMessage>;
};
